import React from "react";
import { FaTimes } from "react-icons/fa";

import { FALLBACK_PUBLICATION_IMAGE } from "../utils/publicationsUtils";

export default function PublicationLightbox({ publication, isOpen, onClose }) {
  if (!isOpen || !publication) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 p-4"
      onClick={onClose}
    >
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
          onClose?.();
        }}
        className="absolute right-4 top-4 z-50 inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white transition hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/70"
        aria-label="Fermer l’image agrandie"
      >
        <FaTimes className="h-4 w-4" />
      </button>

      <img
        src={publication.image}
        alt={publication.imageAlt}
        className="max-h-[95vh] max-w-[95vw] object-contain"
        onClick={(event) => event.stopPropagation()}
        onError={(event) => {
          event.currentTarget.src = FALLBACK_PUBLICATION_IMAGE;
        }}
      />
    </div>
  );
}